import type { FC } from 'react';
import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';
import logo from '../res/img/logo_horizontal_esteso.png';

interface LogoProps {
  sx?: SxProps<Theme>;
}
const Logo: FC<LogoProps> = (props) => (
  <div>
    <img src={logo} width={"150"} height="50"/>
  </div>
);

export default Logo;
